import { FC } from 'react';
import { useGetFcos } from '../../../api/fcos';
import { FeatureViewFCOFields, WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { Empty, Loading } from '@lithos';
import { useUserSettings } from '../../context/UserSettingsContext';
import { TransformServerGroup } from '../../../types/tecton_proto/servergroupservice/server_group_service';
import FeatureViewsList from '../featureViews/FeatureViewsList';

const TransformServerGroupFeatureViewsTableView: FC<{ serverGroup: TransformServerGroup }> = ({ serverGroup }) => {
  const { workspace } = useUserSettings();

  const { data, isLoading, isError } = useGetFcos(workspace ?? '', {
    select: (data: WorkspaceFCOContainer) => {
      return {
        featureViews: data?.featureViews.filter((fv) => {
          const isMatch = fv[FeatureViewFCOFields.TRANSFORM_SERVER_GROUP_NAME] === serverGroup.name;
          return isMatch;
        }),

        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  if (isLoading) {
    return <Loading />;
  }

  if (isError) {
    return (
      <Empty
        placement="full-page"
        actions={[]}
        useCase="errorUnknown"
        title="Unknown Error"
        description="Error loading feature views"
      />
    );
  }

  return (
    <FeatureViewsList
      items={data?.featureViews ?? []}
      idToFcoMap={data?.idToFcoMap ?? {}}
      workspace={workspace ?? ''}
    />
  );
};

export default TransformServerGroupFeatureViewsTableView;
